import { createApp } from 'vue';
import { createPinia } from 'pinia';
import 'quill/dist/quill.snow.css';
import App from './App.vue';
import './styles/index.css';
import router from './router';

const app = createApp(App);
app.use(router);
app.use(createPinia());
app.mount('#app');
